import { LocalTabs } from '../../rahmen/LocalTabs';

/**
 * BM-5 (20.10.2026, TX-STANDARD S1.1): Die drei Seiten der Brandfallsteuerung, der Sprachalarmanlage und des
 * Zutritts als LocalTabs auf ihre eigenen Routen - statt der Reiter `.reiter` auf `elektro-sicherheitstechnik`.
 * Der Reiterzustand steht damit in der Adresse; Sprachalarm und Zutritt haben seit BM-1 eigene Routen (E2).
 */
export function SicherheitsReiter({ projektId }: { projektId: string }) {
  const basis = `/projekte/${projektId}`;
  return (
    <LocalTabs
      ariaLabel="Brandfallsteuerung, Sprachalarm und Zutritt"
      eintraege={[
        { to: `${basis}/elektro-sicherheitstechnik`, beschriftung: 'BMA und RWA', end: true },
        { to: `${basis}/elektro-sprachalarm`, beschriftung: 'Sprachalarmanlage', end: true },
        { to: `${basis}/elektro-zutritt`, beschriftung: 'Zutritt, Fluchttür, Türüberwachung', end: true },
      ]}
    />
  );
}
